import {
  AccountingActionEnum,
  AccountingActionCategory,
} from "./accounting-action-enum";

export const AccountingActionLabel = Object.freeze({
  // Barang & Jasa
  [AccountingActionEnum.INVENTORY]: "Persediaan",
  [AccountingActionEnum.SALES_REVENUE]: "Penjualan",
  [AccountingActionEnum.SALES_RETURN]: "Retur Penjualan",
  [AccountingActionEnum.SALES_DISCOUNT]: "Diskon Penjualan",
  [AccountingActionEnum.GOODS_IN_TRANSIT]: "Barang Terkirim",
  [AccountingActionEnum.COST_OF_GOODS_SOLD]: "Beban Pokok Penjualan",
  [AccountingActionEnum.PURCHASE_RETURN]: "Retur Pembelian",
  [AccountingActionEnum.EXPENSE]: "Beban",
  [AccountingActionEnum.UNBILLED_PAYABLES]: "Pembelian Belum Tertagih",

  // Perusahaan - Neraca
  [AccountingActionEnum.OPENING_BALANCE_EQUITY]: "Ekuitas Saldo Awal",
  [AccountingActionEnum.RETAINED_EARNINGS]: "Laba Ditahan",

  // Perusahaan - Laba/Rugi
  [AccountingActionEnum.INCOME_TAX_EXPENSE]: "Pajak Penghasilan",

  // Perusahaan - Penggajian Karyawan
  [AccountingActionEnum.PPH21_PAYABLE]: "Utang PPh21",
  [AccountingActionEnum.PENSION_PAYABLE]: "Utang Premi Pensiun",
  [AccountingActionEnum.HEALTH_INSURANCE_PAYABLE]: "Utang Premi Kesehatan",

  // Perusahaan - Peminjaman Karyawan
  [AccountingActionEnum.EMPLOYEE_LOAN_RECEIVABLE]: "Piutang Pinjaman Karyawan",
  [AccountingActionEnum.LOAN_INTEREST_RECEIVABLE]: "Piutang Bunga Pinjaman",
  [AccountingActionEnum.DEFERRED_INTEREST_INCOME]:
    "Pendapatan Bunga Ditangguhkan",
  [AccountingActionEnum.LOAN_INTEREST_INCOME]: "Pendapatan Bunga Pinjaman",
  [AccountingActionEnum.LOAN_PENALTY_INCOME]: "Pendapatan Denda Pinjaman",

  // Penjualan/Pembelian - Penerimaan/Pembayaran
  [AccountingActionEnum.PAYMENT_DISCOUNT]: "Akun Diskon",

  // Penjualan/Pembelian - Faktur Pembelian
  [AccountingActionEnum.TAX_ROUNDING_DIFFERENCE]: "Akun Pembulatan",

  // Persediaan - Penyesuaian Persediaan
  [AccountingActionEnum.INVENTORY_ADJUSTMENT]: "Akun Penyesuaian",

  // Persediaan - Perintah Stok Opname
  [AccountingActionEnum.STOCK_OPNAME_VARIANCE]: "Beban Selisih Stok",

  // Persediaan - Pekerjaan Pesanan
  [AccountingActionEnum.WORK_IN_PROGRESS]: "Akun Pekerjaan",
  [AccountingActionEnum.JOB_COST_VARIANCE]: "Selisih Biaya",

  // Pelanggan - Kustomisasi Akun Penjualan
  [AccountingActionEnum.ACCOUNTS_RECEIVABLE]: "Piutang",
  [AccountingActionEnum.SALES_DOWN_PAYMENT]: "Uang Muka",
  [AccountingActionEnum.ITEM_DISCOUNT]: "Diskon Barang",

  // Pemasok - Akun Pembelian
  [AccountingActionEnum.ACCOUNTS_PAYABLE]: "Akun Utang",
  [AccountingActionEnum.PURCHASE_DOWN_PAYMENT]: "Akun Uang Muka",
});

export const AccountingActionCategoryLabel = Object.freeze({
  [AccountingActionCategory.GOODS_AND_SERVICES]: "Barang & Jasa",
  [AccountingActionCategory.COMPANY]: "Perusahaan",
  [AccountingActionCategory.SALES_PURCHASE]: "Penjualan/Pembelian",
  [AccountingActionCategory.INVENTORY]: "Persediaan",
  [AccountingActionCategory.CUSTOMER]: "Pelanggan",
  [AccountingActionCategory.SUPPLIER]: "Pemasok",
});
